__turbopack_context__.v({
  "commentIcon": "SuggestionBox-module__qcyVOG__commentIcon",
  "description": "SuggestionBox-module__qcyVOG__description",
  "form": "SuggestionBox-module__qcyVOG__form",
  "header": "SuggestionBox-module__qcyVOG__header",
  "suggestionBox": "SuggestionBox-module__qcyVOG__suggestionBox",
  "textArea": "SuggestionBox-module__qcyVOG__textArea",
  "title": "SuggestionBox-module__qcyVOG__title",
  "visuallyHidden": "SuggestionBox-module__qcyVOG__visuallyHidden",
});
